export default __webpack_public_path__ + "static/media/Reliving Mantram.1cee5de7.jpg";